
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.759 3H17.24c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 011.748 1.748c.239.468.339.966.387 1.505a1 1 0 01.03.5c.02.45.02.971.02 1.57v6.482c0 .805 0 1.47-.045 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 01-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 01-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 16.71 1 16.046 1 15.242V8.758c0-.599 0-1.12.018-1.57a1 1 0 01.031-.5c.048-.54.148-1.037.387-1.505a4 4 0 011.748-1.748c.485-.247 1.002-.346 1.564-.392C5.29 3 5.954 3 6.758 3zM3 8.92v6.28c0 .383 0 .712.004.998l4.537-4.099-4.54-3.178zM9.7 11.169l-6.616-4.63c.036-.208.082-.342.135-.446a2 2 0 01.874-.874c.157-.08.38-.145.82-.18C5.361 5 5.943 5 6.8 5h10.4c.857 0 1.439 0 1.889.038.439.035.663.1.82.18a2 2 0 01.873.874c.053.104.1.238.135.445l-6.615 4.631a.964.964 0 00-.035.024l-1.005.704c-.73.51-.884.599-1.02.633a1 1 0 01-.484 0c-.136-.034-.29-.123-1.02-.633l-1.005-.704a1.03 1.03 0 00-.034-.024zm-.477 2.108l-5.66 5.113c.152.159.331.292.53.393.157.08.38.145.82.18C5.361 19 5.943 19 6.8 19h10.4c.857 0 1.439 0 1.889-.038.439-.035.663-.1.82-.18.198-.101.377-.234.53-.393l-5.66-5.113-.37.259a42.26 42.26 0 00-.116.08c-.544.383-1.023.719-1.567.855a3 3 0 01-1.452 0c-.544-.136-1.022-.472-1.567-.854a42.326 42.326 0 00-.115-.081l-.37-.259zm7.237-1.177l4.538 4.099C21 15.91 21 15.583 21 15.2V8.92l-4.54 3.18z","fill":"#fff"}})])
          )
        }
      }
    